export default "__VITE_ASSET__GyZa5QZQv8YBG2evmh_Z6Q__"